export const SHORT_STATES = {
    Alabama: 'AL',
    Alaska: 'AK',
    Arkansas: 'AR',
    Arizona: 'AZ',
    California: 'CA',
    Colorado: 'CO',
    Connecticut: 'CT',
    Delaware: 'DE',
    'District of Columbia': 'DC',
    Florida: 'FL',
    Georgia: 'GA',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    Utah: 'UT',
    Vermont: 'VT',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
    'U.S. Armed Forces - Europe': 'AE',
    'U.S. Armed Forces - Americas': 'AA',
    'U.S. Armed Forces - Pacific': 'AP',
    'Puerto Rico': 'PR',
    'American Samoa': 'AS',
    Guam: 'GU',
    'Northern Mariana Islands': 'MP',
    'US Virgin Islands': 'VI',
    'US Minor Outlying Islands': 'UM',
    'Marshall Islands': 'MH',
    Micronesia: 'FM',
    Palau: 'PW',
};
export const FULL_STATES = Object.keys(SHORT_STATES).reduce((acc, key) => {
    acc[SHORT_STATES[key]] = key;
    return acc;
}, {});
export const USA_STATES = Object.keys(SHORT_STATES);
export const USA_STATES_OPTIONS = USA_STATES.map((state) => ({
    label: state,
    value: state,
}));
//# sourceMappingURL=unitedStates.js.map